export const REQUEST_BLOB_URL = "REQUEST_BLOB_URL";
export const RECEIVE_BLOB_URL = "RECEIVE_BLOB_URL";
export const RESET_BLOB = "RESET_BLOB";
export const UPDATE_BLOB_PROGRESS = "UPDATE_BLOB_PROGRESS";

export const REQUEST_ARTIST_TRACKS = "REQUEST_ARTIST_TRACKS";
export const RECEIVE_ARTIST_TRACKS = "RECEIVE_ARTIST_TRACKS";

export const REQUEST_ARTIST_DETAILS = "REQUEST_ARTIST_DETAILS";
export const RECEIVE_ARTIST_DETAILS = "RECEIVE_ARTIST_DETAILS";

export const START_SEARCH = "START_SEARCH";
export const FINISH_SEARCH = "FINISH_SEARCH";

export const UPDATE_SEARCH_FILTER_CONDITION = "UPDATE_SEARCH_FILTER_CONDITION";
export const UPDATE_SEARCH_FILTER_SIZE = "UPDATE_SEARCH_FILTER_SIZE";
export const CLEAR_SEARCH_FILTERS = "CLEAR_SEARCH_FILTERS";

export const UPDATE_ARTIST_NAME = "UPDATE_ARTIST_NAME";
export const CLEAR_ARTIST_NAME = "CLEAR_ARTIST_NAME";

export const UPDATE_TRACK_NAME = "UPDATE_TRACK_NAME";
export const CLEAR_TRACK_NAME = "CLEAR_TRACK_NAME";

export const UPDATE_MAX_RESULTS = "UPDATE_MAX_RESULTS";
export const CLEAR_MAX_RESULTS = "CLEAR_MAX_RESULTS";

export const SET_SELECTED_SCRAPER = "SET_SELECTED_SCRAPER";

export const SET_TABLE_CONFIG = "SET_TABLE_CONFIG";

export const SET_SELECTED_TRACK = "SET_SELECTED_TRACK";
export const CLEAR_SELECTED_TRACK = "CLEAR_SELECTED_TRACK";
